import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import {useDispatch, useSelector} from "react-redux";
import {changeCrudSnackbar} from "./crudSnackbarSlice";
import {changeExternalData} from "../ExternalData/externalDataSlice";



const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function NoSearchCriteriaSnackbar() {

    const selectorSnackbarOpen = useSelector((state) => state.externalDataSlc.value.snackbarOpen);
    const selectorSnackbarSeverity = useSelector((state) => state.externalDataSlc.value.snackbarSeverity);
    const selectorSnackbarMessage = useSelector((state) => state.externalDataSlc.value.snackbarMessage);

    const dispatchData = useDispatch();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatchData(changeExternalData({snackbarOpen: false, snackbarSeverity: "", snackbarMessage: ""}))

        console.log("Snackbar open:", selectorSnackbarOpen);


    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={selectorSnackbarOpen}
            autoHideDuration={3000}
            transitionDuration={{ enter: 500, exit: 500 }}
            onClose={handleClose}
        >
            <Alert
                onClose={handleClose}
                severity={selectorSnackbarSeverity}
                sx={{ width: '100%' }}>
                {selectorSnackbarMessage}
            </Alert>
        </Snackbar>
    );
}
